jQuery(function ($) {
	const base = "growl-component-create-review";
	if (!$(`.${base}`).length) {
		return;
	}

	// Converting Image to the base64
	function convertImgToBase64URL(url, callback, outputFormat) {
		let img = new Image();
		img.crossOrigin = "Anonymous";
		img.onload = function () {
			let canvas = document.createElement("canvas"),
				ctx = canvas.getContext("2d"),
				dataURL;
			canvas.height = (300 * img.height) / img.width;
			canvas.width = 300;
			ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
			dataURL = canvas.toDataURL(outputFormat);
			callback(dataURL);
			canvas = null;
		};
		img.src = url;
	}

	gform.addFilter(
		"gform_file_upload_markup",
		function (html, file, up, strings, imagesUrl, response) {
			return `<img class="image" src=""><img class="gform_delete" src="${imagesUrl}/delete.png" onclick="gformDeleteUploadedFile(${up.settings.multipart_params.form_id} , ${up.settings.multipart_params.field_id}, this)" alt="${strings.delete_file}" title="${strings.delete_file}">`;
		}
	);

	const upload_field = document.querySelector(`.${base}` + " input[name=gform_uploaded_files]");
	const observer = new MutationObserver(function () {
		let images = JSON.parse(upload_field.value);
		const input_key = Object.keys(images)[0];
		images = images[input_key];

		for (let i = 0; i < images.length; i++) {
			convertImgToBase64URL(
				`${growl_reviews_upload_path}${images[i].temp_filename}`,
				function (base64Img) {
					$(`.ginput_container_fileupload + div > div:nth-of-type(${i + 1}) .image`).attr(
						"src",
						base64Img
					);
				}
			);
		}
	});
	// Image path to file can only be found in #gform_uploaded_files, so we observe attribute change.
	observer.observe(upload_field, { attributes: true });

	function highlight(id, value) {
		for (let i = 1; i <= 5; i++) {
			if (i <= value) {
				$(`.${base}` + " #" + `${id}` + " input" + `[value="${i}"]`).addClass("selected");
			} else {
				$(`.${base}` + " #" + `${id}` + " input" + `[value="${i}"]`).removeClass(
					"selected"
				);
			}
		}
	}

	function highlight_current(el) {
		const id = $(el).closest(".gfield_radio").attr("id");
		highlight(id, $(`.${base}` + " #" + `${id}` + " input:checked").val());
	}

	// Stars
	enable_stars_select = function () {
		$(`.${base}` + " .gfield_radio input").on("mouseover", function () {
			highlight($(this).closest(".gfield_radio").attr("id"), this.value);
		});

		$(`.${base}` + " .gfield_radio input").on("mouseleave", function () {
			highlight_current($(this));
		});
	};
	enable_stars_select();

	$(document).on("gform_page_loaded", function () {
		$(`.${base}` + " .gfield_radio").each(function () {
			highlight_current($(this));
		});
		enable_stars_select();
	});
});
